
	import Vue from "vue";
	import helpers from "../inc/helpers";
	import api from "../api";

	import LevyMarketValueSearchResult from "../components/LevyMarketValueSearchResult.vue";

	import TaxRate from "../data/TaxRate";
	import moment from "moment";

	export default Vue.extend({
		props: ["note", "disclaimer"],

		data() {
			return {
				isLoading: true,
				isSearchReady: false,
				form: {
					isSearching: false,
					values: {
						propertyTypes: ["Agricultural", "Commercial", "Industrial", "Residential"],
						taxRates: [] as Array<TaxRate>,
					},
					fields: {
						marketValue: null as null | string,
						taxDistrict: null as null | TaxRate,
					},
					error: null as null | string,
				},
			};
		},

		mounted() {
			api.getTaxRates().then((taxRates: Array<TaxRate>) => {
				this.form.values.taxRates = taxRates;
				this.isLoading = false;
			});
		},

		methods: {
			submitForm() {},

			clearForm() {
				this.form.fields.marketValue = null;
				this.form.fields.taxDistrict = null;

				this.resetForm();
			},

			resetForm() {
				this.form.error = null;
			},
		},

		computed: {
			lastYear(): string {
				return moment()
					.subtract(1, "year")
					.format("Y");
			},

			thisYear(): string {
				return moment().format("Y");
			},

			sortedTaxRates(): Array<TaxRate> {
				return this.form.values.taxRates.sort((a: TaxRate, b: TaxRate) => parseInt(a.gca_tax_rate_district_number) - parseInt(b.gca_tax_rate_district_number));
			},
		},

		filters: {
			formatCurrency(val: string): string {
				return helpers.formatCurrency(val);
			},

			formatTaxDistrictNumber(number: number): string {
				return number.toString();
			},
		},

		components: {
			LevyMarketValueSearchResult,
		},
	});
